import { defineMutation, useMutation, useQueryCache } from '@pinia/colada';

import { getPropertyStatisticsQueryKey, portfolioQueryKey } from '@tallo/investor/property';
import { renterConversationQueryKey, renterInquiriesQueryKey } from '@tallo/investor/renter';

import { showingsQueryKey } from '../queries/showings.query';
import showingRequestsService from '../services/showing-requests.service';

export const useDeclineShowingRequest = defineMutation(() => {
  return useMutation({
    mutation(payload: { propertyId: string; showingRequestId: string; declineReason?: string }) {
      return showingRequestsService.decline(payload.propertyId, payload.showingRequestId, payload.declineReason);
    },
    async onSuccess(_, payload) {
      const queryCache = useQueryCache();

      queryCache.invalidateQueries({ key: getPropertyStatisticsQueryKey(payload.propertyId) });
      queryCache.invalidateQueries({ key: [portfolioQueryKey] });
      queryCache.invalidateQueries({ key: [renterInquiriesQueryKey] });
      queryCache.invalidateQueries({ key: [renterConversationQueryKey] });
      await queryCache.invalidateQueries({ key: [showingsQueryKey] });
    },
  });
});
